import { Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const TikTokIcon = ({ size = 18, strokeWidth = 1.25 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

export default function Footer({ settings }) {
  return (
    <footer data-testid="site-footer" className="bg-cream border-t border-hairline mt-32">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-20 grid md:grid-cols-3 gap-12">
        <div>
          {settings?.logo_url && <img src={settings.logo_url} alt="Tammy's Treats" className="h-16 w-auto mb-6" />}
          <p className="text-sm text-ink-soft font-light leading-relaxed max-w-xs">
            Handcrafted floral buttercream cupcakes & edible art for weddings, special occasions, and quiet celebrations.
          </p>
        </div>
        <div>
          <p className="overline mb-6">Visit</p>
          <p className="text-sm text-ink mb-2">{settings?.location || "Mooresville, NC"}</p>
          <p className="text-sm text-ink mb-2">{settings?.phone}</p>
          <p className="text-sm text-ink">{settings?.email}</p>
        </div>
        <div>
          <p className="overline mb-6">Follow the Craft</p>
          <div className="flex items-center gap-6">
            {settings?.instagram_url && (
              <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="text-ink hover:text-rose transition-colors">
                <Instagram strokeWidth={1.25} />
              </a>
            )}
            {settings?.facebook_url && (
              <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="text-ink hover:text-rose transition-colors">
                <Facebook strokeWidth={1.25} />
              </a>
            )}
            {settings?.tiktok_url && (
              <a href={settings.tiktok_url} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" className="text-ink hover:text-rose transition-colors">
                <TikTokIcon />
              </a>
            )}
          </div>
          <p className="text-xs text-ink-soft mt-8">{settings?.instagram_handle}</p>
        </div>
      </div>
      <div className="border-t border-hairline">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row justify-between items-center text-xs text-ink-soft">
          <p>© {new Date().getFullYear()} Tammy's Treats. Edible floral art, made with patience.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="elegant-link mt-2 md:mt-0">Studio Login</Link>
        </div>
      </div>
    </footer>
  );
}
